import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { promise } from 'protractor';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  template: ` <ion-content>
    <ion-header>
      <ion-toolbar
        ><ion-title>{{ title }}</ion-title></ion-toolbar
      ></ion-header
    >
    <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>
    <ion-list [inset]="true">
      <ion-item
        *ngFor="let item of list"
        (click)="select(item)"
        [button]="true"
      >
        <ion-label>
          <h1>{{ item.title }}</h1>
          <p *ngIf="item.subTitle">{{ item.subTitle }}</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </ion-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SheetModalSelectComponent implements OnInit {
  title: string;
  list: { title: string; subTitle: string; val: any }[] = [];
  dataPromise: Promise<{ title: string; subTitle: string; val: any }[]>;
  loading = false;
  constructor(
    private modalCtrl: ModalController,
    private _cd: ChangeDetectorRef,
    private _shared: SharedService,
  ) {}

  async ngOnInit() {
    this.loading = true;
    this._cd.detectChanges();
    if (this.dataPromise) {
      this.list = await this.dataPromise.catch((err) => {
        this._shared.showErrorToast('Помилка завантаження');
        return [];
      });

      alert(JSON.stringify(this.list));
    }

    this.loading = false;
    this._cd.detectChanges();
  }

  select(item: any) {
    this.modalCtrl.dismiss(item.val);
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
